import { atom, useAtom } from 'jotai';

export const useLoginFailedModalAtom = atom(false);

export function useLoginFailedModal() {
  const [open, setOpen] = useAtom(useLoginFailedModalAtom);

  return {
    value: open,
    open: () => setOpen(true),
    close: () => setOpen(false),
  };
}
